import React, { useState } from 'react';
import { Button, Grid, Typography, ListItemIcon, Menu, MenuItem } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Delete, Edit } from '@mui/icons-material';
import FAQHeader from './FAQHeader';

function CommonFAQ(props) {
  const { heading, faq, handleEditFAQ, handleDeleteFAQ, isMobile } = props;
  const role = localStorage.getItem('role');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event, data) => {
    setSelectedIndex(data.id)
    setAnchorEl(event.currentTarget);

  };
  const handleEditClick = () => {
    const selectedItemData = faq.find(ele => ele.id === selectedIndex)
    handleEditFAQ(selectedItemData)
  }
  const handleDeleteClick = () => {
    const selectedItemData = faq.find(ele => ele.id === selectedIndex)
    handleDeleteFAQ(selectedItemData)
  }

  const handleClose = () => {
    setAnchorEl(null);
  }
  return (
    <Grid container
      direction='column'>
      {role !== "adminCompany" && isMobile ?
        '' : role === 'adminCompany' ? '' : <Grid>
          <FAQHeader />
        </Grid>}
      <Grid item container
        direction='column'>
        {role !== "adminCompany" && isMobile ? '' : role === 'adminCompany' ? '' :
          <Grid item className='marginTopLeft'>
            <span className="arrowIcon">
              <ArrowBackIosIcon /></span>
            <span className='headingAlign'>{heading}</span>
          </Grid>}
        {heading === "About ITER Services" ?
          <Grid item
            alignItems='center'
            justifyContent='center'
            className={role !== "adminCompany" ? 'marginLeftRight fontAlign' : 'fontAlign'}
          >

            {faq?.map((ele, idx) => (
              <Grid container key={idx} className='mt15 faqBg'>
                <Grid item md={11.5}>
                  <Typography className='mt3'><span>{idx + 1}.
                  </span>{ele.question}</Typography>
                  <Typography className='mt3'>{ele.answer}</Typography>
                </Grid>
                {role === "adminCompany" ? <Grid item md={0.5}>
                  {/* TODO need to uncomment or remove */}
                  {/* <EditDeleteFAQ  /> */}
                </Grid> : null}
              </Grid>

            ))}
          </Grid> :

          <Grid item
            alignItems='center'
            justifyContent='center'
            className={role !== "adminCompany" ? 'marginLeftRight fontAlign' : 'fontAlign'}
          >
            {faq?.map((ele, idx) => (
              <Grid container key={idx} className='mt15 faqBg'>
                <Grid item md={11.5}>
                  <Typography className='font18 fontMedium '><span>{idx + 1}.
                  </span>{ele.question}</Typography>
                  <Typography className='font18 mt3'>{ele.answer}</Typography>
                </Grid>
                {role === "adminCompany" ? <Grid item md={0.5}>

                  <Button onClick={(event) => handleClick(event, ele)}
                  >
                    <div className="colorBlack">{
                      <MoreVertIcon />}
                    </div>
                  </Button>
                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    className=''
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                  >
                    <MenuItem onClick={() => handleEditClick()} >
                      <ListItemIcon  >
                        <Edit fontSize="small" />
                      </ListItemIcon>
                      Edit
                    </MenuItem>
                    <MenuItem onClick={() => handleDeleteClick()}>
                      <ListItemIcon>
                        <Delete fontSize="small" />
                      </ListItemIcon>
                      Delete
                    </MenuItem>
                  </Menu>
                </Grid> : null}
              </Grid>

            ))}
          </Grid>
        }
      </Grid>
    </Grid>


  )
}

export default CommonFAQ
